<div class="w-full md:w-10/12 mx-auto py-4">

    <div class="w-full flex justify-end mb-4">
        <mat-icon class="cursor-pointer"
            [svgIcon]="'heroicons_solid:x-mark'"
            (click)="cerrar()"
            [class.opacity-50]="subiendoPlantilla"
            [class.pointer-events-none]="subiendoPlantilla"
            [attr.aria-disabled]="subiendoPlantilla">
        </mat-icon>
    </div>

    <div
        class="flex flex-col items-center justify-center relative w-full sm:h-20 md:h-32 bg-gray-100 border-2 border-dashed border-gray-300 p-2 rounded-md"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">

            <div class="font-bold mb-2 hidden md:flex">Seleccione un Archivo o Arrastrelo Aquí</div>
            <button (click)="uploadImage()" [disabled]="subiendoPlantilla" class="w-8/12 md:w-4/12 h-12 border border-gray-300 rounded-md flex items-center justify-center bg-[#f4f4f4] hover:bg-[#e0e0e0]">
            <mat-icon class="">cloud_upload</mat-icon>
            <p class="pl-2 text-sm md:text-md">Seleccionar Archivos</p>
            </button>

            <input
            type="file"
            accept="application/pdf,.pdf"
            (change)="onFileSelected($event)"
            class="hidden"
            #fileInput
            [disabled]="subiendoPlantilla"
            required>

    </div>

    <div>
        <table mat-table [dataSource]="documentos" class="w-full mt-4" *ngIf="documentos.length > 0">

            <!-- nombreArchivo Column -->
            <ng-container matColumnDef="nombreArchivo">
                <td mat-cell *matCellDef="let doc">
                <div class="flex gap-2 items-center">
                    <document-icon [tipoDocumento]="'PDF'" [background]="'bg-red-600'"></document-icon>
                    <div class="flex flex-col">
                    <span class="font-medium leading-5">{{ doc.name }}</span>
                    <span class="text-sm font-normal">
                        {{ (doc.size / 1024).toFixed(1) }} KB
                    </span>
                    </div>
                </div>
                </td>
            </ng-container>

            <!-- eliminarDocumento Column -->
            <ng-container matColumnDef="eliminarDocumento">
                <td mat-cell *matCellDef="let doc; let i = index">
                <button mat-icon-button (click)="borrar(i)" [disabled]="subiendoPlantilla">
                    <mat-icon [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                </button>
                </td>
            </ng-container>

            <tr mat-row *matRowDef="let row; columns: ['nombreArchivo', 'eliminarDocumento']" class="border-b"></tr>
            </table>
    </div>
    <div class="w-full flex justify-end mt-8">

      <button mat-fab class="rounded-md w-32 h-10"
        (click)="guardarPlantilla()"
        [color]="'primary'"
        [disabled]="this.documentos.length === 0 || subiendoPlantilla">
        Cargar Plantilla
      </button>
    </div>
  </div>
